import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=5b10776a&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=5b10776a&prod&scoped=true&lang=css"
import style1 from "./TopBar.vue?vue&type=style&index=1&id=5b10776a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10776a",
  null
  
)

export default component.exports